var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('home-swiper'),(!_vm.isHlj)?_c('home-norml-card'):_vm._e(),(!_vm.isCqsw && !_vm.isHlj)?_c('home-advertisement'):_vm._e(),(!_vm.isCqsw)?_c('home-card'):_vm._e(),(!_vm.isCqsw)?_c('home-cooperation'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }